import { BaseError, type BaseErrorParameters } from './base';

export class LinkCredentialError extends BaseError {
  constructor({ cause }: Pick<BaseErrorParameters, 'cause'>) {
    super({
      cause,
      code: 'link_credential_error',
      docsUrl: null,
      name: 'LinkCredentialError',
      shortMessage:
        'The credential you are trying to link is associated with another account and cannot be reassigned.',
    });
  }
}
